import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChartAxis2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStackedBarChartAxis2"><Path d="M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 18.5V9.5H12.5V18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 18.5V6.5H18.5V18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStackedBarChartAxis2;
